// ============================================================================
// Talk N' Fix — central mock data (frontend only for now).
// Editing anything here updates the whole site. Later this maps to a backend.
// ============================================================================

export const business = {
  name: "Talk N' Fix",
  sub: "Freehold",
  tagline: "5-Star Device Repair in Freehold, NJ",
  phone: "(732) 484-5119",
  phoneRaw: "tel:7324845119",
  email: "varrockrepair@gmail.com",
  addressLine1: "Freehold Raceway Mall",
  addressLine2: "3710 US-9, Freehold, NJ 07728",
  floor: "2nd Level · By the Food Court",
  rating: "4.9",
  reviewsCount: "695",
  reviewsLabel: "700+ 5-Star Google Reviews",
  directionsUrl: "https://maps.app.goo.gl/P9fDEVdVq36oWYK87",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4630.954583377187!2d-74.30295522281166!3d40.253281671466425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3d42ff763c517%3A0x986d0582da0342f4!2sTalk%20N%27%20Fix!5e1!3m2!1sen!2sus!4v1781801445161!5m2!1sen!2sus",
  hours: [
    { day: "Monday – Saturday", time: "10:00 AM – 9:00 PM" },
    { day: "Sunday", time: "11:00 AM – 6:00 PM" },
  ],
};

// Top scrolling ticker
export const ticker = [
  { label: "Fixed Fast —", accent: "Same-Day Service", href: "/contact" },
  { label: "365 Emergency Repairs —", accent: "Call Now!", href: business.phoneRaw },
  { label: "700+ 5-Star", accent: "Google Reviews", href: "/contact" },
  { label: "6-Month", accent: "Repair Warranty", href: "/repair-estimate" },
];

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services", hasMenu: true },
  { label: "Pre-Owned Devices", to: "/pre-owned-devices" },
  { label: "Contact Us", to: "/contact" },
];

// ---------------------------------------------------------------------------
// SERVICES
// ---------------------------------------------------------------------------
export const services = [
  {
    slug: "cell-phone-repair",
    title: "Cell Phone Repair",
    short: "Cracked screen? Dying battery? Get your phone repaired in less than 60 minutes.",
    image: "https://framerusercontent.com/images/JUn3K8CducpP4eTHmuqQY4LRpmM.webp?width=1200&height=800",
    heroBg: "https://framerusercontent.com/images/DBPuIdw2y1zlrpFFL2X7GiaLd4.webp?width=2048&height=1152",
    heroTitle: "Cell Phone Repair",
    intro:
      "Tired of living with a broken phone? At Talk N' Fix in Freehold Raceway Mall, we specialize in making your worst tech day disappear in under an hour. Whether it's an iPhone, Samsung, or LG, we restore it to like-new condition with the speed, quality, and guarantee you deserve.",
    badges: [
      { icon: "clock", title: "Super Quick Service", text: "Most phone repairs are completed in less than 60 minutes." },
      { icon: "shield", title: "6-Month Warranty", text: "We stand by our work. Your repair is protected for half a year." },
      { icon: "award", title: "Certified-Quality Parts", text: "No cheap knock-offs. We use premium, certified parts for lasting performance." },
    ],
    problemsTitle: "The Common Phone Problems We Fix Fast",
    problemsIntro:
      "We understand the panic and frustration of a broken phone. We fix all critical issues so you can get back to your everyday life.",
    problems: [
      { title: "Screen Damage", text: "Cracked glass, shattered display, or non-responsive touch functionality. We fix all types of phone screen damage." },
      { title: "Battery Drains Fast", text: "Your phone is dying unexpectedly before the end of the day. Get a long-lasting, reliable phone battery replacement." },
      { title: "Charging Issue", text: "A loose, unresponsive, or damaged charging port that prevents power from reaching the device." },
      { title: "Rear Camera Issue", text: "Blurry pictures, focus problems, or a non-working primary camera." },
      { title: "Front Camera Issue", text: "A failed or poor-quality front-facing camera that ruins video calls and selfies." },
      { title: "Back Housing Glass Damage", text: "Broken back panels on newer phones exposing internal components." },
      { title: "Water / Liquid Damage", text: "Urgent professional service to save your phone after a spill or drop." },
      { title: "Other", text: "Speaker/mic issues, button problems, software glitches, and more." },
    ],
    steps: [
      { title: "Book Your Appointment", note: "Less than 1 min", text: "Tell us your device model and the issue (screen repair, battery replacement, etc.). Book a time slot online or give us a quick call." },
      { title: "The <60 Minute Repair", note: "While you shop", text: "Drop off your device. Our certified technicians perform speedy, precision repairs using high-quality parts." },
      { title: "Pickup & Peace of Mind", note: "Success!", text: "Collect your fixed iPhone (or other device) and enjoy your 6-month warranted device." },
    ],
  },
  {
    slug: "tablet-repair",
    title: "Tablet Repair",
    short: "Cracked iPad screen? Battery won't hold a charge? Get your tablet repaired today.",
    image: "https://framerusercontent.com/images/gOrVI5QJDAcfrNjhOCiLPhBAcQ.webp?width=1280&height=720",
    heroBg: "https://framerusercontent.com/images/DBPuIdw2y1zlrpFFL2X7GiaLd4.webp?width=2048&height=1152",
    heroTitle: "Tablet Repair",
    intro:
      "Is your iPad or tablet screen cracked, or is the battery failing to hold a charge? At Talk N' Fix in Freehold Raceway Mall, we provide fast, expert tablet repair for iPad, Samsung Galaxy Tab, and more — restoring your device to like-new condition with quality parts and a solid guarantee.",
    badges: [
      { icon: "clock", title: "Super Quick Service", text: "Most common tablet repairs are completed with a fast turnaround." },
      { icon: "shield", title: "6-Month Warranty", text: "We stand by our work. Your tablet repair is protected for half a year." },
      { icon: "award", title: "Certified-Quality Parts", text: "Premium, certified parts for crisp displays and lasting performance." },
    ],
    problemsTitle: "The Common Tablet Problems We Fix Fast",
    problemsIntro:
      "From cracked glass to charging headaches, we fix the issues that keep your tablet from working the way it should.",
    problems: [
      { title: "Screen Damage", text: "Cracked glass, shattered display, or unresponsive touch on your iPad or Android tablet." },
      { title: "Battery Drains Fast", text: "Your tablet won't hold a charge through the day. Get a reliable battery replacement." },
      { title: "Charging Issue", text: "A loose, slow, or dead charging port that stops power reaching your device." },
      { title: "Camera Issues", text: "Blurry, failed, or non-working front and rear cameras." },
      { title: "Back Housing Damage", text: "Bent or cracked rear housing exposing internal components." },
      { title: "Water / Liquid Damage", text: "Urgent professional service to rescue your tablet after a spill." },
      { title: "Other", text: "Speaker/mic issues, button problems, software glitches, and more." },
    ],
    steps: [
      { title: "Book Your Appointment", note: "Less than 1 min", text: "Tell us your tablet model and the issue. Book a time slot online or give us a quick call." },
      { title: "The Repair", note: "While you shop", text: "Drop off your device. Our certified technicians perform precise repairs using high-quality parts." },
      { title: "Pickup & Peace of Mind", note: "Success!", text: "Collect your fixed tablet and enjoy your 6-month warranted device." },
    ],
  },
  {
    slug: "computer-repair",
    title: "Mac or PC Repair",
    short: "Broken screen? Virus infected? Get your PC or Mac running like new, fast.",
    image: "https://framerusercontent.com/images/db1VcI8mD1RgnFhilPiNbbjU0.webp?width=735&height=551",
    heroBg: "https://framerusercontent.com/images/DBPuIdw2y1zlrpFFL2X7GiaLd4.webp?width=2048&height=1152",
    heroTitle: "Mac or PC Repair",
    intro:
      "Is your Mac crashing, running at a snail's pace, or refusing to power on? At Talk N' Fix in Freehold Raceway Mall, we provide expert, certified service to bring your desktop or laptop back to optimal performance. We understand your computer is essential for work, school, and life, and we guarantee a fast, quality fix.",
    badges: [
      { icon: "clock", title: "Super Quick Service", text: "Rapid diagnostics and fast turnaround on most common laptop repairs and upgrades." },
      { icon: "shield", title: "6-Month Warranty", text: "We stand by our work. Your computer repair is protected for half a year." },
      { icon: "award", title: "Certified-Quality Parts", text: "From new memory (RAM) to durable screens, we use premium components." },
    ],
    problemsTitle: "The Common Computer Problems We Fix Fast",
    problemsIntro:
      "Don't let tech issues ruin your productivity. We fix the critical hardware and software problems that slow you down.",
    problems: [
      { title: "Screen Damage", text: "Cracked, broken, or defective display panels. Quick, professional laptop screen replacement for all major brands." },
      { title: "Battery Drains Fast", text: "Your laptop battery drains too quickly. Get a long-lasting, reliable battery replacement." },
      { title: "Virus / Malware Removal", text: "Unwanted pop-ups or strange behavior. Complete virus and malware removal to secure your PC or Mac." },
      { title: "Start-up / Hard Drive Failure", text: "Computer won't boot, showing error codes or clicking noises. We resolve boot issues and replace drives." },
      { title: "Memory / Hard Drive Upgrade", text: "System running slow? We install new RAM or faster SSDs to boost speed and storage instantly." },
      { title: "Other", text: "Keyboard/trackpad issues, overheating, OS errors, data recovery, and custom troubleshooting." },
    ],
    steps: [
      { title: "Book Your Appointment", note: "Less than 1 min", text: "Tell us your machine (PC, Mac, Laptop, Desktop) and the issue. Book a diagnostic slot online or call us." },
      { title: "The Repair", note: "Expert service", text: "Drop off your machine. Our techs perform thorough diagnostics and precision repairs. We'll let you know in advance if a part needs ordering." },
      { title: "Pickup & Peace of Mind", note: "Success!", text: "Collect your fully repaired and optimized computer and enjoy your 6-month warranted performance." },
    ],
  },
  {
    slug: "game-console-repair",
    title: "Game Console Repair",
    short: "HDMI port broken? Disc drive not reading? Get your PS5, Xbox, or Switch repaired by certified experts.",
    image: "https://framerusercontent.com/images/3oxb53o1whPoTW8gWQhzfvTiMTs.webp?width=1024&height=538",
    heroBg: "https://framerusercontent.com/images/DBPuIdw2y1zlrpFFL2X7GiaLd4.webp?width=2048&height=1152",
    heroTitle: "Game Console Repair",
    intro:
      "A malfunctioning console can stop your gaming instantly. At Talk N' Fix in Freehold Raceway Mall, we specialize in fixing critical hardware issues on your PlayStation, Xbox, or Nintendo Switch. While complex console repairs may take time to source the exact part, we provide expert diagnostics and promise a high-quality, warranted fix.",
    badges: [
      { icon: "wrench", title: "Expert Diagnosis", text: "We quickly identify the exact cause — from a faulty HDMI port to a disc drive issue." },
      { icon: "shield", title: "6-Month Warranty", text: "We stand by our work. Your console repair is protected for half a year." },
      { icon: "phone", title: "Clear Turnaround Time", text: "We confirm the exact repair time within 24 hours so you know when you'll be back in the game." },
    ],
    problemsTitle: "The Critical Console Problems We Fix Reliably",
    problemsIntro:
      "Don't buy a new console — let us fix the core issues that stop your gameplay.",
    problems: [
      { title: "HDMI / Display Issue", text: "No picture or a distorted image. We repair or replace damaged HDMI ports to restore perfect video output." },
      { title: "Disc Drive Issue", text: "Your console won't accept, read, or eject discs. We fix or replace faulty disc drives on PlayStation or Xbox." },
      { title: "Storage / Hard Drive Issue", text: "Error messages, slow loading, or corrupted data. We replace or upgrade your console's storage." },
      { title: "Power Issue", text: "Won't turn on, shuts off, or flashes error lights. We fix internal power supply problems." },
      { title: "Other", text: "Overheating, controller sync issues, internet connectivity problems, and other internal failures." },
    ],
    steps: [
      { title: "Book Your Appointment", note: "Less than 1 min", text: "Tell us your console model (PS5, Xbox Series X, Switch, etc.) and the issue. Book online or call us." },
      { title: "Diagnosis & Confirmation", note: "Fastest possible", text: "Drop off your console. We diagnose the exact fault and order any necessary parts, then confirm a guaranteed turnaround time." },
      { title: "Pickup & Peace of Mind", note: "Success!", text: "We install the new part, thoroughly test your console, and notify you about pickup. Enjoy your 6-month warranty!" },
    ],
  },
];

export const servicesHero = {
  bg: "https://framerusercontent.com/images/on5hS8UoTMMjjdUyK8qb3TxFmQ.webp?width=2048&height=1152",
  title: "Expert Repair for Every Device You Own",
  text:
    "Your broken technology stops here. At Talk N' Fix New Jersey, we go far beyond just phones. Our 700+ five-star certified technicians are ready to handle repairs for your cell phones, tablets, laptops, and game consoles with speed and guaranteed quality.",
};

// ---------------------------------------------------------------------------
// WHY CHOOSE US  (shared across home + service pages)
// ---------------------------------------------------------------------------
export const whyChooseImage =
  "https://framerusercontent.com/images/u5KxhTRi5a7pSXmFAdeuWKuN5EA.webp?width=500&height=500";

export const whyChoose = [
  { icon: "https://framerusercontent.com/images/xyd02IUDfkPYqXmtSJDUgCRpSQE.png?width=150&height=150", title: "Fixed Fast, Same-Day", text: "Most repairs done same-day — often while you wait." },
  { icon: "https://framerusercontent.com/images/UvuN44Z5Yhr0Ss0et5zlhSzYcRA.png?width=150&height=150", title: "+700 Five-Star Reviews", text: "Hundreds of happy Freehold customers can't be wrong." },
  { icon: "https://framerusercontent.com/images/zA5nji0ZbAC8NWyAPs1bQumAFo.png?width=150&height=150", title: "6-Month Warranty", text: "Every repair is covered on parts and labor." },
  { icon: "https://framerusercontent.com/images/0JMT030byF3mG5daP3pRkNGKRk.png?width=150&height=150", title: "Data Safe Guarantee", text: "We only touch hardware — your data stays 100% private." },
  { icon: "https://framerusercontent.com/images/GoBh8d0YsYzPje5kzw9R1DiZ8I8.png?width=150&height=150", title: "All Device Experts", text: "Phones, tablets, laptops & consoles — all under one roof." },
  { icon: "https://framerusercontent.com/images/qRzgbJvyjbb9M5Zuu7q1VG43tSk.png?width=150&height=150", title: "Authorized Quality Parts", text: "Genuine Apple & Samsung parts, no dealer markup." },
];

// ---------------------------------------------------------------------------
// HOME: Certified Pre-Owned teaser
// ---------------------------------------------------------------------------
export const homePreOwned = {
  image: "https://framerusercontent.com/images/wUhmpx9uCDegoedsjCVT51mlcU.jpg?width=960&height=720",
  eyebrow: "The Smart Upgrade",
  title: "Certified Pre-Owned Devices",
  text:
    "Looking for an iPhone, Mac, iPad or Samsung upgrade without the new price tag? Don't risk buying online. Talk N' Fix offers a curated inventory of fully certified, expertly tested, and warranted used phones, tablets, and computers. The same local experts with 700+ five-star reviews check every device we sell.",
  check: "https://framerusercontent.com/images/0gw7ZJTIEIDlLvDMafJo41pSA.png?width=64&height=64",
  points: [
    "Tested and certified by our local 5-star experts.",
    "Protected by a 6-Month Warranty.",
    "Immediate savings over retail prices.",
  ],
};

// ---------------------------------------------------------------------------
// PRE-OWNED DEVICES PAGE
// ---------------------------------------------------------------------------
export const preOwned = {
  heroBg: "https://framerusercontent.com/images/Oa1WzY7yDeqj98NQp8nD8fYHTCU.webp?width=2048&height=1152",
  heroTitle: "Buy Certified Pre-Owned Phones & Laptops in Freehold, NJ",
  aboutImage: "https://framerusercontent.com/images/E2uFhNRUZPlS07NW57xFX1PaqJA.webp?width=1000&height=1000",
  aboutTitle: "Why Buy Pre-Owned from Talk N' Fix?",
  aboutText:
    "If you're searching for reliable, quality tech without the high price tag of a new device, stop searching online and visit the experts right here in the Freehold Raceway Mall. We offer the safest, fastest, and most trusted selection of certified pre-owned phones, tablets, and computers.",
  guaranteeTitle: "The Talk N' Fix Certified Pre-Owned Guarantee",
  guarantee: [
    { icon: "https://framerusercontent.com/images/lz4HSLKXGlC2WMt9lM3UQXkPTqk.png?width=200&height=200", title: "Quality & Check-Up That's Built to Last", text: "Each device passes our extensive diagnostics, ensuring the battery, ports, cameras, and connectivity are in like-new condition." },
    { icon: "https://framerusercontent.com/images/ySCRVXbLjEqHFKrLnX09VxbGfcw.png?width=200&height=200", title: "Affordable Prices, Zero Compromise", text: "Get the latest iPhone or Samsung Galaxy for hundreds less than retail, without sacrificing quality or signing a lengthy contract." },
    { icon: "https://framerusercontent.com/images/bWz4OhIcvIKQRk6VTnTNrTcBmAo.png?width=200&height=200", title: "Protected by Our 6-Month Guarantee", text: "Every certified pre-owned device comes with a warranty. If anything goes wrong, we'll fix it right here in Freehold." },
    { icon: "https://framerusercontent.com/images/q9RhLGIzN8bSmzS4J7mYz47lDH4.png?width=200&height=200", title: "Walk-In Today, Leave With Your Upgrade", text: "Browse our current inventory at the kiosk and buy your new-to-you device immediately. No shipping delays, no waiting." },
  ],
  inventoryTitle: "Find Your Next Device Today",
  inventoryText: "Our inventory moves fast! We carry the most sought-after models at prices that beat other retailers.",
  devices: [
    { image: "https://framerusercontent.com/images/Zs462DNm0w0Ihhy4Fv5NiRmUZw.webp?width=1024&height=1024", title: "Apple iPhones", text: "All new models, from iPhone 17, iPhone 16, iPhone 15, and more." },
    { image: "https://framerusercontent.com/images/XdIHh6pXO2YyCPFnCbdRTOHiDGM.webp?width=1600&height=864", title: "Samsung Phones", text: "Find the new Galaxy S25, Galaxy S24, and Note series." },
    { image: "https://framerusercontent.com/images/opY3niBjMMmCzdcLbJC7zf7k.webp?width=1920&height=1080", title: "iMacs & MacBooks", text: "From MacBook Pro, MacBook Air, iMac and more." },
    { image: "https://framerusercontent.com/images/rYK4Fv9QKYyUgBvDKawbhlFnkM.webp?width=1280&height=720", title: "iPads & Tablets", text: "Newest models of iPads, Galaxy Tab, Pixel Tablet and more." },
  ],
};

// ---------------------------------------------------------------------------
// REPAIR ESTIMATE PAGE
// ---------------------------------------------------------------------------
export const repairEstimate = {
  heroBg: "https://framerusercontent.com/images/gQJz6oJLkbz6MIfnBE3hFqaCXM.webp?width=2048&height=1152",
  heroTitle: "Free Repair Estimate & Appointment",
  subtitle: "Book Your Free Appointment Today",
  text:
    "The fastest way to ensure we have the parts and time for your fix is to send a quick booking request online. Once submitted, you're welcome to visit our location at the Freehold Raceway Mall, or call us with any immediate questions.",
  benefits: [
    "Same-Day Service",
    "+700 Five-Star Reviews",
    "6-Month Repair Warranty",
    "Data Safe Guarantee",
    "All Device Experts",
    "Authorized Quality Parts",
  ],
};

// ---------------------------------------------------------------------------
// CONTACT PAGE
// ---------------------------------------------------------------------------
export const contact = {
  heroBg: "https://framerusercontent.com/images/wy53rnskHY2aHWaFuHLlGLPMHo.webp?width=2048&height=1152",
  heroTitle: "Contact Talk N' Fix New Jersey",
  heroText:
    "The fastest way to ensure we have the parts and time for your fix is to send a quick booking request online. Once submitted, you're welcome to visit our location at the Freehold Raceway Mall, or call us with any immediate questions.",
  infoTitle: "Contact Information",
  infoText:
    "At Talk N' Fix, your comfort is our top priority. Whether you have a question about a repair, a buy or sell service, or want to schedule your next appointment, we are here for you.",
};

export const serviceTypes = [
  "Phone Repair",
  "Tablet Repair",
  "Computer Repair",
  "Game Console Repair",
  "Wearable & Accessories Repair",
  "Buy & Sell Service",
];

// ---------------------------------------------------------------------------
// TESTIMONIALS (mocked Google reviews — real widget not embedded)
// ---------------------------------------------------------------------------
export const testimonials = [
  { name: "Jessica M.", initial: "J", time: "2 weeks ago", rating: 5, text: "Cracked my iPhone screen and they fixed it in under an hour while I shopped. Looks brand new and the price beat the Apple Store. Incredible service!" },
  { name: "Marcus T.", initial: "M", time: "1 month ago", rating: 5, text: "Brought in my PS5 with an HDMI issue. They diagnosed it fast, kept me updated, and it's been running perfectly since. Highly recommend these guys." },
  { name: "Priya S.", initial: "P", time: "3 weeks ago", rating: 5, text: "My MacBook was crawling. They upgraded my SSD and removed a ton of junk — it feels like a new machine. Friendly, honest, and quick." },
  { name: "David R.", initial: "D", time: "1 week ago", rating: 5, text: "Battery on my Galaxy was dying by noon. Replaced same-day with a quality part and a 6-month warranty. Couldn't ask for more." },
  { name: "Amanda K.", initial: "A", time: "2 months ago", rating: 5, text: "Bought a certified pre-owned iPhone here. Saved hundreds, and it came tested with a warranty. So much safer than buying online." },
  { name: "Kevin L.", initial: "K", time: "5 days ago", rating: 5, text: "Spilled water on my iPad and panicked. They saved it! Super knowledgeable team right inside the mall. Will only come here from now on." },
];

// ---------------------------------------------------------------------------
// LOCAL SEO — areas served & FAQs (answer-engine / GEO content)
// ---------------------------------------------------------------------------
export const areasServed = [
  "Freehold",
  "Freehold Township",
  "Manalapan",
  "Marlboro",
  "Howell",
  "Englishtown",
  "Jackson",
  "Colts Neck",
];

export const faqs = [
  {
    q: "Where is Talk N' Fix located in Freehold, NJ?",
    a: "We're inside the Freehold Raceway Mall at 3710 US-9, Freehold, NJ 07728 — on the 2nd level, right by the food court. Look for us while you shop or grab a bite.",
  },
  {
    q: "How long does a phone or tablet repair take?",
    a: "Most cell phone and tablet repairs — like screen replacements and battery swaps — are completed same-day, often in under 60 minutes while you wait or shop.",
  },
  {
    q: "Do you offer a warranty on repairs?",
    a: "Yes. Every repair at Talk N' Fix is backed by a 6-month warranty covering parts and labor, so you have complete peace of mind.",
  },
  {
    q: "What devices do you repair?",
    a: "We repair iPhones and all Android/Samsung phones, iPads and tablets, MacBooks and PCs, and game consoles including PlayStation, Xbox and Nintendo Switch.",
  },
  {
    q: "Will my data be safe during the repair?",
    a: "Absolutely. We only work on hardware — your photos, files and apps are never touched. Your data stays 100% private.",
  },
  {
    q: "Do you buy and sell used phones near Freehold?",
    a: "Yes. We sell certified pre-owned iPhones, Samsung phones, MacBooks and iPads — all tested and warranted — and we buy devices too. Walk in and browse today.",
  },
];

// Service-specific FAQs keyed by slug
export const serviceFaqs = {
  "cell-phone-repair": [
    { q: "How much does an iPhone screen repair cost in Freehold?", a: "Pricing depends on your exact model, but our certified-quality screen repairs are competitively priced and beat the manufacturer — stop by or call (732) 484-5119 for a free quote." },
    { q: "Can you replace my phone battery the same day?", a: "Yes, most phone battery replacements are done same-day, usually in under an hour, using premium certified parts." },
    { q: "Do you fix water-damaged phones?", a: "We do. Bring it in as soon as possible — the faster we start, the better the chance of a full recovery." },
  ],
  "tablet-repair": [
    { q: "Do you repair cracked iPad screens?", a: "Yes, we repair cracked and unresponsive iPad and Android tablet screens with high-quality parts and a 6-month warranty." },
    { q: "My tablet won't charge — can you fix it?", a: "Most charging issues are a faulty port or battery, both of which we repair quickly at our Freehold Raceway Mall location." },
    { q: "How long does a tablet repair take?", a: "Most common tablet repairs are same-day. We'll confirm the timeline as soon as we diagnose your device." },
  ],
  "computer-repair": [
    { q: "Do you repair both Mac and Windows PCs?", a: "Yes — we service MacBooks, iMacs, and Windows laptops and desktops, from screen replacements to virus removal and SSD upgrades." },
    { q: "Can you make my slow computer faster?", a: "Definitely. Installing an SSD, adding RAM, and cleaning up your system can make an older machine feel brand new." },
    { q: "Do you remove viruses and malware?", a: "Yes, we perform complete virus and malware removal and secure your PC or Mac against future threats." },
  ],
  "game-console-repair": [
    { q: "Do you fix HDMI ports on PS5 and Xbox?", a: "Yes, a damaged HDMI port is one of the most common console repairs we do. We repair or replace it to restore perfect video output." },
    { q: "My console won't read discs — can you help?", a: "We repair and replace faulty disc drives on PlayStation and Xbox consoles so they accept, read and eject discs properly." },
    { q: "How long do console repairs take?", a: "Some console parts need to be ordered, so we confirm an exact turnaround time within 24 hours of diagnosis." },
  ],
};

